var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvanced(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 34,
    viewBox: "0 0 46 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3185 16.8394C33.3185 22.4444 28.7748 26.9882 23.1698 26.9882C17.5648 26.9882 13.021 22.4444 13.021 16.8394C13.021 11.2344 17.5648 6.69067 23.1698 6.69067C28.7748 6.69067 33.3185 11.2344 33.3185 16.8394Z",
    stroke: "#FFFFEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0054 2.78374C43.1717 2.77104 43.2634 2.7828 43.3096 2.79356C43.3036 2.84062 43.2829 2.93063 43.2133 3.08224C43.0767 3.37959 42.8101 3.78108 42.3999 4.28317C41.5844 5.28121 40.278 6.58561 38.5683 8.11005C35.154 11.1543 30.1879 15.0266 24.4801 19.0013C18.7723 22.9759 13.4178 26.2905 9.37823 28.4368C7.35539 29.5116 5.67878 30.2844 4.45987 30.703C3.84665 30.9136 3.37759 31.0244 3.05135 31.0493C2.88501 31.062 2.79339 31.0503 2.7472 31.0395C2.75313 30.9925 2.77388 30.9025 2.84349 30.7508C2.98001 30.4535 3.24667 30.052 3.65689 29.5499C4.4723 28.5519 5.77877 27.2475 7.48848 25.723C10.9027 22.6788 15.8689 18.8065 21.5767 14.8318C27.2845 10.8571 32.6389 7.54255 36.6785 5.39628C38.7014 4.32153 40.378 3.54864 41.5969 3.13006C42.2101 2.91947 42.6792 2.80864 43.0054 2.78374Z",
    stroke: "#FFFFEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8801 24.2749C26.7773 24.2749 29.9367 20.9892 29.9367 16.936C29.9367 12.8829 26.7773 9.59717 22.8801 9.59717C18.9828 9.59717 15.8235 12.8829 15.8235 16.936C15.8235 20.9892 18.9828 24.2749 22.8801 24.2749Z",
    fill: "#FFFFEA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanced);
export default __webpack_public_path__ + "static/media/Advanced.dfb7d592842b05c2afb4955238ed1c1c.svg";
export { ForwardRef as ReactComponent };